import { CssSheet } from "../../actions/types";

export const ShoppingCartNavStyles: CssSheet = {
  platform: {
    isAndroid: false,
    isIos: false,
    isWeb: true,
    isWindows: false,
    os: ["web"],
  },
  route: "ShoppingCartNavList",
  sheet: {
    cartListItem: {
      padding: "2%",
    },
  },
};

export const ShoppingCartNavMobileStyles: CssSheet = {
  platform: {
    isAndroid: true,
    isIos: true,
    isWeb: false,
    isWindows: false,
    os: ["android", "ios"],
  },
  route: "ShoppingCartNavList",
  sheet: {
    cartListItem: {
      padding: "2%",
    },
  },
};
